import seedrandom from 'seedrandom';

export function createDeterministicRNG(seed: string) {
  const rng = seedrandom(seed, {
    global: false,    // Don't modify global Math.random
    entropy: false,   // Don't use additional entropy
    state: false     // Don't maintain state
  });
  
  return {
    // Returns a number between 0 (inclusive) and max (exclusive)
    nextInt: (max: number): number => Math.floor(rng() * max),
    
    // Shuffle array using Fisher-Yates algorithm with our seeded RNG
    shuffle: <T>(array: T[]): T[] => {
      const result = [...array];
      for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(rng() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
      }
      return result;
    }
  };
}